import React from 'react'
import {Toolbar1} from './Toolbar1'
import {useLayout} from '../../../core/layout'

const Toolbar = () => {
  const {config} = useLayout()

  switch (config.toolbar.layout) {
    case 'toolbar1':
      return <Toolbar1 />

    default:
      return <Toolbar1 />
  }
}

export {Toolbar}
